export const fmt = (n) => (n == null ? '—' : '$' + Math.round(n).toLocaleString('en-US'));

export const rowKey = (r) => r.stock_number || `${r.branch}|${r.price}|${r.hours ?? ''}|${r.year ?? ''}`;

export const VERDICT_STYLE = {
    'Model Underperformer': { bg: '#fee2e2', color: '#b91c1c' },
    'Unit Anomaly': { bg: '#fee2e2', color: '#b91c1c' },
    'Category Slowdown': { bg: '#fff7ed', color: '#b45309' },
    'Overpriced vs Peers': { bg: '#fff7ed', color: '#b45309' },
    'Aged vs Peers': { bg: '#fff7ed', color: '#b45309' },
    'Above AI Estimate': { bg: '#fff7ed', color: '#b45309' },
    Outperformer: { bg: '#f0fdf4', color: '#15803d' },
    'High Interest': { bg: '#f0fdf4', color: '#15803d' },
};

export const VERDICT_ORDER = [
    'Model Underperformer',
    'Unit Anomaly',
    'Category Slowdown',
    'Overpriced vs Peers',
    'Aged vs Peers',
    'Above AI Estimate',
    'Outperformer',
    'High Interest',
];

export const speedStyle = (category) => {
    if (!category) return null;
    if (category.startsWith('Fast')) return { color: '#15803d', bg: '#dcfce7' };
    if (category.startsWith('Normal')) return { color: '#1d4ed8', bg: '#dbeafe' };
    if (category.startsWith('Very Slow')) return { color: '#b91c1c', bg: '#fee2e2' };
    if (category.startsWith('Slow')) return { color: '#b45309', bg: '#fff7ed' };
    return null;
};
